import { G2Badge1 } from 'components/icons/g2-badge-1'
import { G2Badge2 } from 'components/icons/g2-badge-2'
import { G2Badge3 } from 'components/icons/g2-badge-3'
import { RasaLogo } from 'components/icons/rasalogo'
import { ReviewSlider } from 'components/review-slider/component'
import React from 'react'

export const LeftNav = () =>
<div className="left-nav">
  <div className="logo"><RasaLogo /></div>
  <ReviewSlider></ReviewSlider>
  <div className="g2-badges">
    <div className="g2-badge">
      <G2Badge1 />
    </div>
    <div className="g2-badge">
      <G2Badge2 />
    </div>
    <div className="g2-badge">
      <G2Badge3 />
    </div>
  </div>
</div>
